import { useEffect, useRef, useState } from 'react';

const AudioController = (url) => {
    const audioRef = useRef(null);
    if (!audioRef.current) {
        audioRef.current = new Audio();
        audioRef.current.preload = 'metadata';
    }
    const audio = audioRef.current;

    const [playing, setPlaying] = useState(false);
    const [duration, setDuration] = useState(0);
    const [curTime, setCurTime] = useState(0);
    const [clickedTime, setClickedTime] = useState(null);

    const toggle = () => setPlaying((prev) => !prev);

    useEffect(() => {
        if (!url) return undefined;

        setPlaying(false);
        setDuration(0);
        setCurTime(0);
        setClickedTime(null);

        audio.src = url;
        audio.load();

        return undefined;
    }, [url, audio]);

    useEffect(() => {
        const onEnded = () => setPlaying(false);
        const setAudioData = () => {
            setDuration(Number.isFinite(audio.duration) ? audio.duration : 0);
            setCurTime(Number.isFinite(audio.currentTime) ? audio.currentTime : 0);
        };
        const setAudioTime = () => {
            setCurTime(Number.isFinite(audio.currentTime) ? audio.currentTime : 0);
        };

        if (playing) {
            const playPromise = audio.play();
            if (playPromise?.catch) {
                playPromise.catch(() => setPlaying(false));
            }
        } else {
            audio.pause();
        }

        audio.addEventListener('loadeddata', setAudioData);
        audio.addEventListener('loadedmetadata', setAudioData);
        audio.addEventListener('durationchange', setAudioData);
        audio.addEventListener('timeupdate', setAudioTime);
        audio.addEventListener('ended', onEnded);

        if (clickedTime != null && clickedTime !== curTime) {
            audio.currentTime = clickedTime;
            setClickedTime(null);
        }

        return () => {
            audio.removeEventListener('loadeddata', setAudioData);
            audio.removeEventListener('loadedmetadata', setAudioData);
            audio.removeEventListener('durationchange', setAudioData);
            audio.removeEventListener('timeupdate', setAudioTime);
            audio.removeEventListener('ended', onEnded);
        };
    }, [playing, audio, clickedTime, curTime]);

    return { playing, toggle, setPlaying, duration, curTime, setClickedTime };
};

export default AudioController;
